<template>
  <FormulateInput
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :optionsGetter="computedOptionsGetter"
    :label="null"
    :help="true"
    :fullObject="fullObject"
    :value="computedValue"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
import * as Uom from '@/services/rest-api/lib/product/uom'

export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    productObj: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return this.value
    },
    computedOptionsGetter() {
      const productId = this.productObj.id
      let optionsGetter = null

      // set optionsGetter if product id is selected
      if (productId !== null || productId !== undefined) {
        optionsGetter = Uom.get(productId)
      }

      return optionsGetter
    },
  },
  watch: {
    productObj(newValue, oldValue) {
      if (newValue.id === oldValue.id) return

      if (newValue.id === undefined) {
        this.$emit('input', null)
        this.$emit('update:fullObject', {})

        return
      }
      
      const newObj = {
        name: newValue.uom,
        weight: newValue.weight,
        volume: newValue.volume,
      }

      this.$emit('input', newObj.name)
      this.$emit('update:fullObject', newObj)
    },
  },
  methods: {
    handleInput(newValue) {
      if (newValue && newValue.length > 0) {
        this.$emit('input', newValue)
        return
      }
      
      // if newValue is empty, always set null
      this.$emit('input', null)
    },
  },
}
</script>
